import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { PlaylistItem } from "./Playlist";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { PlaylistAddButton } from './PlaylistAddButton';
import { UIinput } from '../uikit/UIinput';

function ContentListInner({ playlistId, userId, match }) {
  const context = useContext(Context);
  return (
    <>
      <div className="l_thumbs_day">
        <PerfectScrollbar className={`l_thumbs_ul`}>


          {Boolean(context.data["videos"]
            .filter((one) => {
              return playlistId ? one["playlists"].includes(playlistId) : true
            })
            .filter((one) => {
              return userId ? one["user"].includes(userId) : true
            }).length) && <>
          {context.data["videos"]
            .filter((one) => {
              return playlistId ? one["playlists"].includes(playlistId) : true
            })
            .filter((one) => {
              return userId ? one["user"].includes(userId) : true
            })
            .map((one) => {
              return (
                <PlaylistItem
                  key={`playlist_${one["id"]}`}
                  active={match["params"]["videoId"] === one["id"]}
                  {...one}
                />
              );
            })}
            {/* <PlaylistItem
                key={'processing'}
                id={'new'}
                processing={true}
                title={'New capture'}
                user={context['user']['id']}
              /> */}
            </>}




        </PerfectScrollbar>

        {Boolean(context.data["videos"]
          .filter((one) => {
            return playlistId ? one["playlists"].includes(playlistId) : true
          })
          .filter((one) => {
            return userId ? one["user"].includes(userId) : true
          }).length) && <PlaylistAddButton />
        }



        {!Boolean(context.data["videos"]
          .filter((one) => {
            return playlistId ? one["playlists"].includes(playlistId) : true
          })
          .filter((one) => {
            return userId ? one["user"].includes(userId) : true
          }).length) && <><ContentListEmpty
            handleCapture={() => void (0)}
            handleUpload={() => void (0)}
          />


          <div className="l_thumbs_suggested">

            <div className="l_thumbs_day_title0">
              <div className="l_thumbs_day_title">
                Suggested videos to add
              </div>
            </div>


            <div className="l_thumbs_day_bg" />

            <div className="l_thumbs_ul">
              {context.data["videos"]
                .filter((one, index) => {
                  return one["user"].includes(userId) ? true : false
                })
                .filter((one, index) => {
                  return index < 6 ? true : false
                })
                .map((one) => {
                  return (
                    <PlaylistItem
                      addToPlaylist={playlistId}
                      key={`playlist_${one["id"]}`}
                      active={match["params"]["videoId"] === one["id"]}
                      {...one}
                    />
                  );
                })}
            </div>

          </div>


        </>
        }


      </div>
    </>
  );
}







export function ContentListEmpty({
  title = 'New playlist',
  handleCapture = () => void (0),
  handleUpload = () => void (0),
  handleRename = () => void (0)
}) {
  return (
    <>
      <div className="l_playlist_empty0" style={{ height: '30vh' }}>

        {/* //TODO: For the future */}
        {/* <div className="l_playlist_empty_title"><span className="l_playlist_empty_title_name"
          onClick={() => handleRename()}
        >{title}</span></div>
        <div className="l_playlist_empty_title">is empty</div> */}


        <div className="l_playlist_empty_title">Playlist is empty</div><br />

        <div className="l_playlist_empty_elements">
          <div className="x_add_variant">
            <div className="x_add_variant_ico">
              <div className="ico">
                <div>videocam</div>
              </div>
            </div>
            <div>Capture screen</div>
          </div>
          <div className="x_add_variant">
            <div className="x_add_variant_ico">
              <div className="ico">
                <div>cloud_upload</div>
              </div>
            </div>
            <div>Upload video</div>
          </div>
        </div>
        <br /><br /><br />
      </div>
    </>
  )
}




export const ContentList = withRouter(ContentListInner);